import { Fragment } from "react";

const bold = (line, key) =>
  line.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={`${key}-${i}`} className="font-semibold text-ink">{part.slice(2, -2)}</strong> : <Fragment key={`${key}-${i}`}>{part}</Fragment>);

/** Tiny, safe renderer for the assistant's replies: paragraphs, "- " bullets and **bold** (no HTML injection). */
export const MiniMarkdown = ({ text }) => {
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) blocks.push({ type: "ul", items: list });
    list = [];
  };
  text.split("\n").forEach((raw) => {
    const line = raw.trim();
    if (/^[-*•]\s+/.test(line)) list.push(line.replace(/^[-*•]\s+/, ""));
    else {
      flush();
      if (line) blocks.push({ type: "p", text: line });
    }
  });
  flush();
  return (
    <div className="space-y-2">
      {blocks.map((b, i) =>
        b.type === "ul" ? (
          <ul key={i} className="space-y-1 pl-4">{b.items.map((it, j) => <li key={j} className="list-disc marker:text-brass">{bold(it, `${i}-${j}`)}</li>)}</ul>
        ) : (
          <p key={i}>{bold(b.text, i)}</p>
        ))}
    </div>
  );
};
